import Effects from './Effects';
import Contents from './Contents';
import Sun from './Sun';
import ParticleScape from './ParticleScape';
import Sky from '../common/Sky';
import dysonSkyEffects from './dysonSkyEffects.json';
import Spiral from './Spiral';
import Camera from './Camera';
import VisibilityGroup from '../common/VisibilityGroup';

export default function Dyson() {
  return (
    <VisibilityGroup beaker="chapter2">
      <pointLight
        color={ [1, 0.92, 0.88] }
        intensity={ 120 }
        position={ [0, 0, 0] }
        decay={ 2 }
        distance={ 600 }
      />
      <Contents />
      <Spiral />
      <Sun />
      <ParticleScape />
    </VisibilityGroup>
  );
};

export const Mount = () => {
  return (
    <Sky
      beaker="chapter2"
      effects={ dysonSkyEffects }
    />
  );
};

export { Camera, Effects };